<nav class="navbar {{ this.authenticationService.currentUser.code_parrainage }}">
    <div class="row">
        <div class="col-12 text-center">
            <a routerLink="/app/" *ngIf="authenticationService.currentUser.code_parrainage != 'SEBMORE' && authenticationService.currentUser.code_parrainage != 'PURPLE'"
               class="logo">
                <img src="assets/logo-inline-alpha.png">
            </a>
            <a routerLink="/app/" *ngIf="authenticationService.currentUser.code_parrainage == 'SEBMORE'" class="logo logo_sebastienmore">
                <img src="assets/sebastienmore.jpg">
                <span class="by-lybox">
                    par <img class="ms-2" src="assets/logo.png">
                </span>
            </a>
            <a routerLink="/app/" *ngIf="authenticationService.currentUser.code_parrainage == 'PURPLE'" class="logo logo_purple">
                <img src="assets/pdf/purpleimmobilier/LOGO%20purple.png">
                <span class="by-lybox">
                    par <img class="ms-2" src="assets/logo.png">
                </span>
            </a>

            <ng-container *ngIf="authenticationService.isLogin">
                <div class="promo_header d-none d-lg-inline-block"
                     *ngIf="(authenticationService.currentUser.plan == 'trial' || authenticationService.currentUser.plan == 'trial_plus' || authenticationService.currentUser.plan == '') && authenticationService.currentUser.pro_plan == '' && authenticationService.currentUser.subscription.status == ''">
                    <a [routerLink]="[url_plan]"
                       (click)="trackingService.click('header_see_forfait','');">
                        <i class="fa cfa cfa-star me-2"></i>
                        Voir les forfaits
                    </a>
                </div>
                <div class="alert_header d-none d-lg-inline-block"
                     *ngIf="showPromo">
                    <a [routerLink]="[url_plan]"
                       (click)="trackingService.click('header_end_trial','');">
                        <i class="fa cfa cfa-clock-o me-2"></i>
                        Votre promotion sera automatiquement désactivée dans {{ promoDelay[0] }} jour{{ promoDelay[0] > 1 ? 's' : '' }}, {{ promoDelay[1] }} heure{{ promoDelay[1] > 1 ? 's' : '' }} et {{ promoDelay[2] }} minute{{ promoDelay[2] > 1 ? 's' : '' }}
                    </a>
                </div>
                <div class="alert_header d-none d-lg-inline-block"
                     *ngIf="trialDay > 0 && trialDay <= 7 && (authenticationService.currentUser.plan == 'trial' || authenticationService.currentUser.plan == '') && authenticationService.currentUser.pro_plan == ''">
                    <a [routerLink]="[url_plan]"
                       (click)="trackingService.click('header_end_trial','');">
                        <i class="fa cfa cfa-clock-o me-2"></i>
                        Votre période d'essai expire dans {{ trialDay | number:'1.0-0' }} jour{{ trialDay >= 1.5 ? 's' : '' }}
                    </a>
                </div>
                <div class="alert_header d-none d-lg-inline-block"
                     *ngIf="trialDay > 0 && trialDay <= 7 && (authenticationService.currentUser.plan == 'trial_plus' || authenticationService.currentUser.plan == '') && authenticationService.currentUser.pro_plan == ''">
                    <a [routerLink]="[url_plan]"
                       (click)="trackingService.click('header_end_trial','');">
                        <i class="fa cfa cfa-clock-o me-2"></i>
                        Votre plan Essentiel expire dans {{ trialDay | number:'1.0-0' }} jour{{ trialDay >= 1.5 ? 's' : '' }}
                    </a>
                </div>
                <div class="alert_header d-none d-lg-inline-block"
                     *ngIf="showBadEmail">
                    <a [routerLink]="[url_plan]"
                       (click)="trackingService.click('header_bad_email','');">
                        <i class="fa cfa cfa-clock-o me-2"></i>
                        Votre mail n'est pas éligible pour la période d'essai gratuite. Veuillez utiliser une véritable adresse mail.
                    </a>
                </div>
                <div class="alert_header d-none d-xl-inline-block cursor-pointer"
                     *ngIf="trialDay == 0 && authenticationService.currentUser.subscription.status == 'past_due' && authenticationService.currentUser.pro_plan == ''">
                    <a (click)="trackingService.click('header_not_paid','');updateCB()">
                        <i class="fa cfa cfa-warning me-2"></i>
                        Le paiement de votre abonnement a échoué et vos accès ont été désactivés. Pour régulariser votre
                        situation, <u>cliquez ici</u>
                    </a>
                </div>
                <div class="warning_header d-none d-sm-inline-block cursor-pointer"
                     *ngIf="expired_card == true">
                    <a (click)="trackingService.click('header_not_paid','');updateCB()">
                        <i class="fa cfa cfa-warning me-2"></i>
                        Votre carte {{authenticationService.currentUser.payment_method.type_detail}} {{authenticationService.currentUser.payment_method.last_4}} arrive à expiration
                        en {{authenticationService.currentUser.payment_method.exp_month}}/{{authenticationService.currentUser.payment_method.exp_year}}.
                        <u>Cliquez ici pour changer votre carte et continuer à utiliser LyBox</u>.
                    </a>
                </div>

                <!-- Desktop : dropdown Bootstrap -->
                <div class="dropdown dropstart hide-mobile">
                    <button class="btn dropdown-toggle me-2" type="button" id="dropdownUser"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                            [stepContent]="userDropdownStepContent"
                            [joyrideStep]="'userDropdownStep'">
                        <i class="fa cfa cfa-user text-white"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownUser">
                        <ng-container *ngTemplateOutlet="userMenuContent"></ng-container>
                    </div>
                </div>
                <!-- Mobile : même contenu en popup (moule mobile) -->
                <div class="dropdown dropstart visible-mobile">
                    <button class="btn me-2" type="button" [matMenuTriggerFor]="userMobileMenu" #userMobileTrigger="matMenuTrigger">
                        <i class="fa cfa cfa-user text-white"></i>
                    </button>
                    <mat-menu #userMobileMenu="matMenu" class="mobile-sheet header-sheet-menu" backdropClass="mobile-sheet-backdrop">
                        <!-- Le contenu (pictoList desktop) n'utilise pas mat-menu-item :
                             on ferme au clic sur un lien/une action, sinon le menu resterait ouvert -->
                        <div (click)="closeMenuOnAction($event, userMobileTrigger)">
                            <ng-container *ngTemplateOutlet="userMenuContent"></ng-container>
                        </div>
                    </mat-menu>
                </div>

                <ng-template #userMenuContent>
                        <p class="pictoListTitle">
                            <b>{{ authenticationService.currentUser.firstname }} {{ authenticationService.currentUser.lastname }}</b><br/>
                            Mon forfait :
                            <ng-container *ngIf="authenticationService.currentUser.pro_plan != ''">
                                <b>Offre pro</b>
                            </ng-container>
                            <ng-container *ngIf="authenticationService.currentUser.pro_plan == ''">
                                <b>{{ (authenticationService.currentUser.plan != '' ? (authenticationService.currentUser.plan == 'trial' || authenticationService.currentUser.plan == 'trial_plus' ? 'Période d\'essai' : (authenticationService.currentUser.plan == 'pro' ? 'Chasseur immobilier' : (authenticationService.currentUser.plan == 'partner' ? 'Partenaire' : authenticationService.currentUser.plan | titlecase))) : "Compte découverte")  }}</b>
                            </ng-container>
                            <!-- Compte découverte : aucun crédit IA fourni, on n'affiche pas le solde -->
                            <ng-container
                                *ngIf="authenticationService.currentUser.pro_plan != '' || authenticationService.currentUser.plan != ''">
                                <span aria-hidden="true"> | </span>
                                <b>{{ aiCreditService.credit }} crédit{{ aiCreditService.credit > 1 ? 's' : '' }} IA</b>
                            </ng-container>
                        </p>
                        <ul class="pictoList">
                            <li *ngIf="authenticationService.currentUser.plan == 'trial'">
                                <a [routerLink]="[url_plan]">
                                    <i class="fa cfa cfa-clock-o" aria-hidden="true"></i>
                                    <p class="content">Votre période d'essai expire
                                        dans {{ trialDay | number:'1.0-0' }} jour{{ trialDay >= 1.5 ? 's' : '' }}</p>
                                </a>
                            </li>
                            <li *ngIf="authenticationService.currentUser.plan == 'trial_plus'">
                                <a [routerLink]="[url_plan]">
                                    <i class="fa cfa cfa-clock-o" aria-hidden="true"></i>
                                    <p class="content">Votre plan Essentiel expire
                                        dans {{ trialDay | number:'1.0-0' }} jour{{ trialDay >= 1.5 ? 's' : '' }}</p>
                                </a>
                            </li>
                            <li>
                                <a href="/app/user/account">
                                    <i class="fa cfa cfa-user" aria-hidden="true"></i>
                                    <p class="content">Mon compte</p>
                                </a>
                            </li>
                            <li>
                                <a href="/app/user/settings">
                                    <i class="fa cfa cfa-cog" aria-hidden="true"></i>
                                    <p class="content">Mes préférences</p>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="[url_plan]" *ngIf="authenticationService.currentUser.pro_plan == '' || authenticationService.currentUser.pro_plan == 'lybox'">
                                    <i class="fa cfa cfa-star" aria-hidden="true"></i>
                                    <p class="content" *ngIf="authenticationService.currentUser.pro_plan == '' && (authenticationService.currentUser.plan == '' || authenticationService.currentUser.plan == 'trial')">Souscrire à un
                                        abonnement</p>
                                    <p class="content" *ngIf="authenticationService.currentUser.pro_plan == 'lybox' || (authenticationService.currentUser.plan != '' && authenticationService.currentUser.plan != 'trial')">Gérer mon
                                        abonnement</p>
                                </a>
                            </li>
                            <li *ngIf="authenticationService.currentUser.pro_plan == 'lybox'">
                                <a routerLink="/app/admin">
                                    <i class="fa fa-shield" aria-hidden="true"></i>
                                    <p class="content">Administration</p>
                                </a>
                            </li>
                            <li>
                                <a (click)="trackingService.click('header_logout','');logout()">
                                    <i class="fa cfa cfa-logout" aria-hidden="true"></i>
                                    <p class="content">
                                        Déconnexion</p>
                                </a>
                            </li>
                        </ul>
                </ng-template>

                <!-- Desktop : dropdown Bootstrap -->
                <div class="dropdown dropstart me-3 hide-mobile">
                    <button class="btn dropdown-toggle btn-outline-white" type="button" id="dropdownHelp"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                            [stepContent]="menuCompteStepContent"
                            joyrideStep="menuCompteStep">
                        ?
                    </button>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownHelp">
                        <ng-container *ngTemplateOutlet="helpMenuContent"></ng-container>
                    </div>
                </div>
                <!-- Mobile : même contenu en popup (moule mobile) -->
                <div class="dropdown dropstart me-3 visible-mobile">
                    <button class="btn dropdown-toggle btn-outline-white" type="button" [matMenuTriggerFor]="helpMobileMenu" #helpMobileTrigger="matMenuTrigger">
                        ?
                    </button>
                    <mat-menu #helpMobileMenu="matMenu" class="mobile-sheet header-sheet-menu" backdropClass="mobile-sheet-backdrop">
                        <div (click)="closeMenuOnAction($event, helpMobileTrigger)">
                            <ng-container *ngTemplateOutlet="helpMenuContent"></ng-container>
                        </div>
                    </mat-menu>
                </div>

                <ng-template #helpMenuContent>
                        <ul class="pictoList">
                            <li *ngIf="authenticationService.currentUser.user_onboarding.dismiss == true">
                                <a (click)="trackingService.click('header_open_onboarding','');openOnboarding()">
                                    <i class="fa fa-mouse-pointer" aria-hidden="true"></i>
                                    <p class="content">Ouvrir la visite guidée</p>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.lybox.fr/tutoriel-lybox">
                                    <i class="fa cfa cfa-youtube" aria-hidden="true"></i>
                                    <p class="content">Tutoriels</p>
                                </a>
                            </li>
                            <li>
                                <a href="https://blog-investissement-immobilier.lybox.fr/lexique-immobilier/lexique-immobilier/"
                                   target="_blank">
                                    <i class="fa cfa cfa-question" aria-hidden="true"></i>
                                    <p class="content">Lexique / FAQ</p>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.thomas-cornu.fr/accompagnement-immobilier" target="_blank">
                                    <i class="fa cfa cfa-call" aria-hidden="true"></i>
                                    <p class="content">Coaching immobilier</p>
                                </a>
                            </li>
                            <li>
                                <a routerLink="/app/appli-mobile">
                                    <i class="fa cfa cfa-mobile" aria-hidden="true"></i>
                                    <p class="content">Appli Mobile</p>
                                </a>
                            </li>
                        </ul>
                </ng-template>
            </ng-container>

            <ng-container *ngIf="!authenticationService.isLogin">
                <a [routerLink]="['/app/register']" [queryParams]="{returnUrl: returnUrl}"
                   class="btn btn-info ps-5 pe-5 float-right" type="button">
                    <span>Essai gratuit</span>
                </a>
                <a [routerLink]="['/app/login']" [queryParams]="{returnUrl: returnUrl}"
                   class="btn btn-outline-white ps-3 pe-3 me-2 me-sm-3 float-right d-none d-sm-block" type="button">
                    <span>Se connecter</span>
                </a>
            </ng-container>
        </div>
    </div>
</nav>

<!-- Onboarding -->
<ng-template #menuCompteStepContent>
    <div class="user_onboarding_content">
        <h2>En cas de besoin</h2>
        <p>
            Si vous voulez revenir sur la visite guidée de LyBox, vous pouvez la retrouver dans le menu d’aide.
        </p>
    </div>
</ng-template>

<ng-template #userDropdownStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Pour accéder à la <b>personnalisation de vos préférences</b>, cliquez sur votre nom en haut à droite, puis
            “Mes préférences”
        </p>
    </div>
</ng-template>
